﻿import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SurveysRoutingModule } from './surveys-routing.module';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PublicSurveyListComponent } from './public-survey-list/public-survey-list.component';
import { MySurveyListComponent } from './my-survey-list/my-survey-list.component';;
import { AllSurveyListComponent } from './all-survey-list/all-survey-list.component'

@NgModule({
    declarations: [
        PublicSurveyListComponent,
        MySurveyListComponent,
        AllSurveyListComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        SurveysRoutingModule,
        ReactiveFormsModule
    ],
})
export class SurveysModule { }